import * as React from 'react';

function MonitorSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="prefix__Illustration prefix__Hero__svg"
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 374.47 469.64"
      {...props}>
      <defs>
        <clipPath id="prefix__b">
          <path fill="none" d="M133.98 248.2h52.38v81.84h-52.38z" />
        </clipPath>
        <clipPath id="prefix__a">
          <path fill="none" d="M128.39 240.73h184.29v95.74H128.39z" />
        </clipPath>
      </defs>
      <g data-name={1}>
        <path
          className="prefix__leaf"
          d="M21 212.33a32.58 32.58 0 008 15 32.55 32.55 0 001.58-16.92 32.41 32.41 0 00-8-15A32.47 32.47 0 0021 212.33z"
          fill="#56af96"
        />
        <path
          className="prefix__leaf"
          data-name="leaf"
          d="M41.55 215.6c-1.88 8.82-9.17 15-9.17 15s-4.23-8.14-2.34-17 9.17-15 9.17-15 4.23 8.18 2.34 17zM11.43 229.36c5.38 12.16 14.92 26.25 14.92 26.25s.82-19.62-4.56-31.78a52.9 52.9 0 00-14.92-19.25 59.1 59.1 0 004.56 24.78zM49.8 229C45.15 241.5 36 256.26 36 256.26s-1.55-19.54 3.1-32a54 54 0 0113.8-20.33A59.54 59.54 0 0149.8 229z"
          fill="#6fdcbf"
        />
        <path
          className="prefix__leaf"
          data-name="leaf"
          d="M18.89 226.43c2.66 11.21 9.58 25.93 9.58 25.93s2.62-17.45 0-28.66a47.6 47.6 0 00-9.59-18.92 51.12 51.12 0 00.01 21.65z"
          fill="#6fdcbf"
        />
        <path
          className="prefix__leaf"
          data-name="leaf"
          d="M18.73 229.91c2.26 9.55 8.87 22.92 8.87 22.92s2.93-16.1.67-25.65a35.83 35.83 0 00-8.87-15.92 38.82 38.82 0 00-.67 18.65z"
          fill="#52b292"
        />
        <path
          className="prefix__leaf"
          data-name="leaf"
          d="M29.87 228.72c-1.23 11.64 4.06 29.89 4.06 29.89s7.31-16.63 8.55-28.27-4.06-21.88-4.06-21.88-7.3 8.62-8.55 20.26z"
          fill="#56af96"
        />
        <path
          className="prefix__leaf"
          data-name="leaf"
          d="M25.51 238.91a32.56 32.56 0 004.88 16.28 32.51 32.51 0 004.89-16.28c0-9-4.89-23.28-4.89-23.28s-4.88 14.29-4.88 23.28z"
          fill="#a4d3ba"
        />
        <path
          d="M41.62 244.68c-.09-.81-23.24-4.2-23.15-3.37l2.82 25.17a.68.68 0 00.23.44.58.58 0 00.49.25h18.24c.45 0 .64-.1.76-.41a3.8 3.8 0 00.18-.82q1.06-10.6 1.72-21.26c.09-.83-1.24-.82-1.29 0z"
          fill="#ad998a"
        />
        <path
          d="M45.54 240.37c-.5-.54-1.54-.64-3.54-.64H20.21c-2 0-3 .06-3.47.57s-.41 1.12-.36 2.23v2.29c0 1.55 0 2.4.5 2.92s1.56.58 3.3.58H42c2 0 2.93 0 3.44-.55s.42-1.13.38-2.35v-1.39c0-.53 0-1.14.06-1.59.05-.97.12-1.61-.34-2.07z"
          fill="#c1ab9d"
        />
        <path
          d="M17.93 240.84a8.43 8.43 0 00-.25 3.39c.07.52.89.53.82 0a7.94 7.94 0 01.22-3.18.41.41 0 00-.79-.21zm.54 5.04a.41.41 0 000-.82.41.41 0 000 .82zm20.84 8.6c-.17.74-.37 1.85.57 2.16s1.43-.49 1.48-1.23a1.75 1.75 0 00-1-1.89 1.09 1.09 0 00-1.13.47 1.57 1.57 0 00-.18.42c-.06.25 0 .47 0 .71a.86.86 0 00.58 1 .83.83 0 001-.58 4.2 4.2 0 000-.51v-.19c0-.25-.11-.17-.31.26h-.44c-.17-.06-.28-.24-.16.08s-.32 0 .27-.12h.44c.24.05.33.83.4.25a1.89 1.89 0 01.08-.4c.24-1-1.35-1.47-1.59-.44zm1.59-1.25a.82.82 0 000-1.64.82.82 0 000 1.64zm-.27 5.21a.82.82 0 000-1.64.82.82 0 000 1.64z"
          fill="#fff"
          opacity={0.49}
        />
        <g>
          <path
            d="M68.68 267.43l9.62-34.51a1.4 1.4 0 00-1.09-1.82l-6.44-2a1.39 1.39 0 00-1.91.91l-9.62 34.52a.44.44 0 00.26.56.43.43 0 00.52-.32l.12-.37 7.86 2.43"
            fill="#6fdcbf"
          />
          <path
            d="M71 230.48a1.37 1.37 0 00-1.65 1l-9.14 32.95 3.79 1.19 9.56-34.33z"
            fill="#d2d8db"
          />
          <path
            d="M68 266.83l9.13-32.95a1.38 1.38 0 00-.8-1.76l-2.74-.83L64 265.62l4 1.21"
            fill="#e2e6e8"
          />
          <path d="M70.43 246.27s2.09-9.92 4.2-14c-.55 2.54-.63 3.73-4.2 14z" fill="#a3aeb2" />
          <path fill="#af91db" d="M72.53 238.97l3.05.93-.22-1.92 1.36-1.43-3.16-.96-1.03 3.38z" />
          <path fill="#a3d9e8" d="M89.09 267.77v-49.76h11.21v49.76" />
          <path fill="#6fdcbf" d="M89.1 224.33h11.2v1.79H89.1zM89.1 226.93h11.2v1.79H89.1z" />
          <path fill="#dd859c" d="M78.38 267.77v-45.4h10.59v45.4" />
          <path
            fill="#fff"
            opacity={0.54}
            d="M78.38 232.29h10.59v1.62H78.38zM78.38 234.64h10.59v1.62H78.38z"
          />
        </g>
        <g>
          <path
            d="M292.27 379.94h-14.49c-1.9-6.55 16.34-6.73 14.49 0z"
            fill="#babcbe"
            fillRule="evenodd"
          />
          <path
            d="M277.81 378c1.46-4.11 12.87-4.36 14.42 0a18.53 18.53 0 01-14.42 0z"
            fill="#e5e6e7"
            fillRule="evenodd"
          />
          <path
            d="M285.72 375.08a.09.09 0 01-.09.09h-1.22a.09.09 0 01-.09-.09v-.37c0-.11.26-.2.57-.2h.26c.31 0 .57.09.57.2z"
            fill="#424243"
            fillRule="evenodd"
          />
          <rect x={272.26} y={379.9} width={25.52} height={0.81} rx={0.3} fill="#b2b2d8" />
        </g>
        <path fill="#404040" d="M10.16 266.81h99.83v4.23H10.16z" />
        <g>
          <path
            d="M181.07 121.86c0 7.11-5.26 12.88-11.75 12.88s-11.74-5.77-11.74-12.88S162.84 109 169.32 109s11.75 5.74 11.75 12.86z"
            fill="#fff9cc"
          />
          <path
            fill="#fff4c5"
            style={{
              mixBlendMode: 'luminosity',
            }}
            className="prefix__beam"
            opacity={0.45}
            d="M142.97 121.86L48.99 380.3h248.79L195.57 121.86h-52.6z"
          />
          <path fill="#af91db" d="M168.26-21.21h2.14v91.08h-2.14z" />
          <path
            d="M172.27 72.32v-2.79a2.38 2.38 0 00-2.27-2.47h-1.37a2.38 2.38 0 00-2.26 2.47v2.79a7.77 7.77 0 015.89 0z"
            fill="#b2b2d8"
          />
          <path
            d="M178 81.25V90l-.36-.08a54.11 54.11 0 00-15.25-.19l-1.36.19-.37.08v-8.75a10.88 10.88 0 01.1-1.41 9.69 9.69 0 01.32-1.48c0-.06 0-.12.05-.18a7.23 7.23 0 01.26-.7.42.42 0 010-.12l.18-.41c.07-.15.14-.3.22-.44a10.34 10.34 0 011-1.51 9.67 9.67 0 011.43-1.43c.16-.12.32-.25.5-.36a4.93 4.93 0 01.54-.34 6 6 0 01.55-.31l.56-.24a7.77 7.77 0 012.93-.58 7.87 7.87 0 013 .58 9.19 9.19 0 015.3 6 10.2 10.2 0 01.4 2.93z"
            fill="#af91db"
          />
          <path
            d="M195.67 121.86H143l1.58-12.67c1-7.93 8.11-17.48 16.1-19.2l.37-.08 1.43-.2a54.74 54.74 0 0115.18.2l.34.09c8 1.72 15.14 11.27 16.11 19.2z"
            fill="#af91db"
          />
          <path
            d="M178 81.25h-17.35a10.88 10.88 0 01.1-1.41 9.69 9.69 0 01.32-1.48h16.5a10.2 10.2 0 01.43 2.89zm0 5.95V90l-.36-.08a54.11 54.11 0 00-15.25-.19l-1.36.19-.37.08v-2.67c3-.3 6.17-.46 9.38-.46 2.7 0 5.36.13 7.96.33zM195.67 119.86h-54.73v3.76h56.77v-3.76h-2.04z"
            fill="#b2b2d8"
          />
        </g>
        <rect x={37.83} y={380.3} width={282} height={10} rx={5} fill="#404040" />
        <g>
          <path
            d="M90.8 362a.87.87 0 01-1.74 0 2.14 2.14 0 00-.27-.89 3.33 3.33 0 00-.91-1.11 1.87 1.87 0 00-1.16-.41 1.79 1.79 0 00-.72.2l-.16.09a2.23 2.23 0 00-1 1.61 4.56 4.56 0 00.58 2.75c.08.16.18.34.29.52a17.28 17.28 0 002.71 3c1.79 1.72 3.65 3.51 4.2 6a.87.87 0 11-1.69.38c-.44-1.95-2.11-3.55-3.71-5.1a18.07 18.07 0 01-3-3.38c-.12-.2-.24-.41-.35-.63a6.31 6.31 0 01-.75-3.82 4 4 0 011.85-2.83l.28-.15a3.5 3.5 0 011.46-.39 3.6 3.6 0 012.25.76 5 5 0 011.41 1.71 4 4 0 01.43 1.69z"
            fill="#cc7d96"
          />
          <path
            d="M107.54 356.89c.08 4.69-1.07 19.42-4.84 23.22h-8.08c-3.77-3.8-4.92-18.53-4.84-23.22z"
            fill="#dd859c"
            fillRule="evenodd"
          />
        </g>
        <g>
          <path fill="#d2cfd6" d="M238.13 377.72l-2.47-15.74h-30.45l-2.47 15.74h35.39z" />
          <path
            d="M124.59 363.8a3.31 3.31 0 01-3.3-3.31v-18.76h198.29v18.76a3.32 3.32 0 01-3.31 3.31z"
            fill="#fff"
          />
          <path
            d="M319.33 342v18.51a3.06 3.06 0 01-3.06 3.06H124.59a3.06 3.06 0 01-3-3.06V342h197.74m.5-.5H121v19a3.56 3.56 0 003.55 3.56h191.72a3.56 3.56 0 003.56-3.56v-19z"
            fill="#404040"
          />
          <path
            d="M314.36 234.24H126.51a5.45 5.45 0 00-5.47 5.43v103.2h198.79v-103.2a5.45 5.45 0 00-5.47-5.43z"
            fill="#404040"
          />
          <path fill="#e3d1e5" d="M128.39 240.73h184.29v95.74H128.39z" />
          <path fill="#eaeaea" d="M188.3 377.72h64.27v2.36H188.3z" />
          <ellipse cx={220.43} cy={353.63} rx={3.84} ry={3.81} fill="#333" />
          <g clipPath="url(#prefix__a)">
            <path fill="#565266" d="M193.2 240.73h119.55v95.74H193.2z" />
            <path fill="#b0baea" d="M193.2 240.73h119.55v6.45H193.2z" />
            <ellipse cx={198.98} cy={243.95} rx={1.4} ry={1.38} fill="#e84d4d" />
            <ellipse cx={204.19} cy={243.95} rx={1.4} ry={1.38} fill="#f2dd77" />
            <ellipse cx={209.14} cy={243.95} rx={1.4} ry={1.38} fill="#4eb785" />
            <path
              d="M200.08 252.61c1.17-.07 1.49-.16 1.49-.37s-.33-.43-1.24-.55v-.34l1.11-.86h-1.3v-.68h2.05l.06.68-1.06.8c.83.18 1.15.51 1.15.9 0 .6-.67 1.05-2.21 1.13zm3.05.63l-.07-.61c1-.7 1.5-1.16 1.5-1.61s-.32-.5-1.4-.53l.07-.72c1.63 0 2.11.46 2.11 1s-.5 1.14-1.32 1.76h1.39v.67zm-3.05 6.02c1.17-.07 1.49-.17 1.49-.38s-.33-.42-1.24-.54V258l1.11-.87h-1.3v-.67h2.05l.06.67-1.06.81c.83.17 1.15.51 1.15.89 0 .61-.67 1.06-2.21 1.14zm3.05.63l-.07-.61c1-.71 1.5-1.16 1.5-1.61s-.32-.5-1.4-.53l.07-.73c1.63 0 2.11.47 2.11 1s-.5 1.15-1.32 1.77h1.39v.67zm-3.05 6.02c1.17-.07 1.49-.17 1.49-.38s-.33-.42-1.24-.54v-.34l1.11-.87h-1.3v-.67h2.05l.06.67-1.06.81c.83.17 1.15.51 1.15.89 0 .61-.67 1.06-2.21 1.14zm5.15.09v.59h-.73V266h-1.44a11.57 11.57 0 01.33-2.88l.84.05-.55 2.16h.82v-1.13l.73-.08v1.16h.37l-.07.67zm-5.15 6.56c1.17-.08 1.49-.17 1.49-.38s-.33-.43-1.24-.54v-.35l1.11-.86h-1.3v-.68h2.05l.06.68-1.06.81c.83.17 1.15.51 1.15.89 0 .6-.67 1.06-2.21 1.13zm3.09.71v-.72c1.17-.09 1.53-.2 1.53-.49s-.39-.42-1.44-.54l.11-1.77h2l-.06.69H204v.59c1.11.17 1.44.56 1.44 1-.04.63-.7 1.15-2.27 1.24zm-3.09 5.93c1.17-.07 1.49-.16 1.49-.37s-.33-.43-1.24-.55v-.34l1.11-.86h-1.3v-.68h2.05l.06.68-1.06.81c.83.17 1.15.51 1.15.89 0 .6-.67 1.05-2.21 1.13zm2.92-.65c0-1 .56-1.73 1.83-2.27l.32.65c-.84.31-1.19.61-1.33 1 .78-.45 1.67-.08 1.67.8a1.25 1.25 0 11-2.49-.17zm1.76.23c0-.48-.41-.67-1-.4v.09c0 .59.25.83.56.83s.44-.17.44-.52zm-4.68 7.07c1.17-.07 1.49-.16 1.49-.37s-.33-.43-1.24-.55v-.34l1.11-.86h-1.3v-.68h2.05l.06.68-1.06.8c.83.18 1.15.51 1.15.9 0 .6-.67 1.05-2.21 1.13zm3.31.6a13.46 13.46 0 011.31-2.67h-1.6l.06-.7h2.33v.68a14.72 14.72 0 00-1.3 2.8zm-3.31 6.05c1.17-.07 1.49-.17 1.49-.38s-.33-.42-1.24-.54v-.34l1.11-.87h-1.3v-.67h2.05l.06.67-1.06.81c.83.17 1.15.51 1.15.89 0 .61-.67 1.06-2.21 1.14zm2.92-.17a.92.92 0 00.05-1.74c0-.48.42-1 1.22-1 .63 0 1.13.33 1.13.84a1 1 0 01-.61.86c.36.21.68.47.68.89s-.49 1-1.3 1-1.17-.32-1.17-.85zm1.71 0c0-.25-.32-.44-.68-.64a.67.67 0 00-.29.52c0 .25.15.44.5.44s.48-.17.48-.35zm-.32-1.21a.63.63 0 00.27-.48c0-.23-.12-.4-.44-.4s-.42.14-.42.29.28.39.6.56zm-4.31 8.03c1.17-.07 1.49-.17 1.49-.38s-.33-.43-1.24-.54v-.35l1.11-.86h-1.3v-.67h2.05l.06.67-1.06.81c.83.17 1.15.51 1.15.89 0 .6-.67 1.06-2.21 1.14zm3.25.1c.84-.32 1.19-.61 1.33-1-.78.44-1.67.08-1.67-.8a1.25 1.25 0 112.49.17c0 1-.56 1.73-1.83 2.27zm1.41-1.45v-.09c0-.59-.25-.83-.56-.83s-.46.17-.46.51c0 .49.41.67 1.02.41zm-2.58 8.04v.59h-.73v-.59H200a11.57 11.57 0 01.33-2.88l.84.05-.55 2.16h.82v-1.08l.73-.08v1.16h.36l-.06.67zm.78-1.07c0-1.11.51-1.85 1.34-1.85s1.26.65 1.26 1.73-.51 1.85-1.35 1.85-1.25-.65-1.25-1.73zm.75-.07l1.05-.54c-.08-.38-.25-.61-.51-.61s-.54.38-.54 1.08zm1.1.09l-1 .53c.08.37.24.59.5.59s.5-.42.5-1.12zm-2.63 7.7v.58h-.73v-.58H200a11.47 11.47 0 01.33-2.88l.84.05-.55 2.16h.82v-1.08l.73-.08v1.16h.36l-.06.67zm.93.58v-.65h.91v-1.76h-.81v-.57l.81-.09v-.41l.76-.06v2.88h.82l-.06.65zm-.93 6.06v.59h-.73v-.59H200a11.44 11.44 0 01.33-2.87l.84.05-.55 2.15h.82v-1.07l.73-.08v1.15h.36l-.06.67zm.97.59l-.07-.61c1-.71 1.5-1.16 1.5-1.61s-.32-.5-1.4-.53l.07-.73c1.63 0 2.11.47 2.11 1.05s-.5 1.14-1.32 1.76h1.39v.67zm-.97 6.06v.59h-.73v-.59H200a11.57 11.57 0 01.33-2.88l.84.05-.55 2.16h.82V324l.73-.07v1.15h.36l-.06.67zm.99-.04c1.17-.07 1.49-.17 1.49-.38s-.33-.42-1.24-.54v-.34l1.11-.87h-1.3v-.67h2l.06.67-1.06.81c.83.17 1.15.51 1.15.89 0 .61-.67 1.06-2.21 1.14zm-.99 6.69v.57h-.73v-.59H200a11.57 11.57 0 01.33-2.88l.84.05-.55 2.16h.82v-1.08l.73-.08v1.16h.36l-.06.67zm3.07 0v.57h-.73v-.59h-1.44a11.57 11.57 0 01.33-2.88l.84.05-.55 2.16h.82v-1.08l.73-.08v1.16h.37l-.07.67z"
              fill="#706d84"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#a3848d"
              opacity={0.39}
              data-svg-origin="210.5399932861328 250.3300018310547"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 250.33h70.96v3.07h-70.96z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#a58492"
              opacity={0.39}
              data-svg-origin="210.5399932861328 256.9200134277344"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 256.92h75.56v3.07h-75.56z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#a284a3"
              opacity={0.39}
              data-svg-origin="210.5399932861328 263.57000732421875"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 263.57h61.58v3.07h-61.58z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#9084a0"
              opacity={0.39}
              data-svg-origin="210.5399932861328 270.2799987792969"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 270.28h52.68v3.07h-52.68z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#83859e"
              opacity={0.39}
              data-svg-origin="210.5399932861328 276.8599853515625"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 276.86h43.68v3.07h-43.68z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#83929b"
              opacity={0.39}
              data-svg-origin="210.5399932861328 283.55999755859375"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 283.56h73.08v3.07h-73.08z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#829995"
              opacity={0.39}
              data-svg-origin="210.5399932861328 290.4200134277344"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 290.42h85.72v3.07h-85.72z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#84998b"
              opacity={0.39}
              data-svg-origin="210.5399932861328 296.8599853515625"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 296.86h71.54v3.07h-71.54z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#899985"
              opacity={0.39}
              data-svg-origin="210.5399932861328 303.510009765625"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 303.51h67.52v3.07h-67.52z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#979987"
              opacity={0.39}
              data-svg-origin="210.5399932861328 310.1000061035156"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 310.1h32.1v3.07h-32.1z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#999488"
              opacity={0.39}
              data-svg-origin="210.5399932861328 316.75"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 316.75h93.48v3.07h-93.48z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#998e8a"
              opacity={0.39}
              data-svg-origin="210.5399932861328 323.3999938964844"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.54 323.4h67.52v3.07h-67.52z"
            />
            <path
              className="prefix__line"
              data-name="line"
              fill="#998c8c"
              opacity={0.39}
              data-svg-origin="210.4199981689453 330.04998779296875"
              style={{
                transformOrigin: '0 0',
              }}
              d="M210.42 330.05h50.03v3.07h-50.03z"
            />
            <g
              data-svg-origin="283.99497985839844 311.64500427246094"
              style={{
                transformOrigin: '0 0',
              }}>
              <path fill="#333" d="M259.67 294.33h48.74v38.57h-48.74z" />
              <path
                d="M260.33 290.39h47.22a.86.86 0 01.86.86v4.38h-48.83v-4.49a.75.75 0 01.75-.75z"
                fill="#d3d3d3"
              />
              <circle cx={262.39} cy={293.28} fill="#e84d4d" r={1.04} />
              <circle cx={266.28} cy={293.28} fill="#f2dd77" r={1.04} />
              <circle cx={269.99} cy={293.28} fill="#4eb785" r={1.04} />
              <path
                d="M264.11 303.17a.44.44 0 01-.29-.11.37.37 0 010-.56l1.36-1.28-1.36-1.29a.36.36 0 010-.55.41.41 0 01.58 0l1.66 1.56a.36.36 0 01.12.28.36.36 0 01-.12.27l-1.66 1.57a.46.46 0 01-.29.11zM269.33 302.78a.4.4 0 00-.41-.39h-2.42a.39.39 0 100 .78h2.42a.4.4 0 00.41-.39z"
                fill="#83e5ab"
              />
            </g>
            <g className="prefix__webpage" clipPath="url(#prefix__b)">
              <g
                data-svg-origin="133.8800048828125 243.41000366210938"
                style={{
                  transformOrigin: '0 0',
                }}
                transform="translate(0 -145.278)">
                <rect
                  x={133.88}
                  y={243.41}
                  width={52.47}
                  height={242.13}
                  rx={3.57}
                  fill="#f0f0f2"
                />
                <path
                  fill="none"
                  stroke="#dd859c"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.2}
                  d="M141.67 256.81h32.35M141.67 262.1h38.1M141.67 267.4h32.35"
                />
                <rect x={139.83} y={275.67} width={40.59} height={28.15} rx={3.22} fill="#f2c5c2" />
                <path
                  d="M154.57 284.27a5.58 5.58 0 11-5.58-5.35 5.46 5.46 0 015.58 5.35z"
                  fill="#fff"
                  opacity={0.48}
                  style={{
                    mixBlendMode: 'overlay',
                  }}
                />
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.2}
                  opacity={0.68}
                  d="M144.8 299.31h16.76M144.8 294.69h24.52"
                />
                <rect x={139.83} y={308.41} width={37.69} height={49.32} rx={3.34} fill="#bdc0f4" />
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.2}
                  opacity={0.81}
                  d="M146.12 333.39h11.57M146.12 328.77h16.93M146.12 323.91h22.34M146.12 318.62h26.3M146.12 313.32h22.34"
                />
                <g>
                  <rect
                    x={139.83}
                    y={363.82}
                    width={40.59}
                    height={58.46}
                    rx={3.22}
                    fill="#c2e7ef"
                  />
                  <path
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeMiterlimit={10}
                    strokeWidth={1.2}
                    opacity={0.81}
                    d="M144.98 414.13h13.89M144.85 410.5h18.33M144.62 406.69h21.58"
                  />
                  <path
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeMiterlimit={10}
                    strokeWidth={1.2}
                    opacity={0.68}
                    d="M144.68 402.92h20.12M144.75 399.16h13.75"
                  />
                  <rect
                    x={144.8}
                    y={368.54}
                    width={29.22}
                    height={23.21}
                    rx={6.86}
                    fill="#fff"
                    opacity={0.48}
                    style={{
                      mixBlendMode: 'overlay',
                    }}
                  />
                </g>
                <g>
                  <rect
                    x={140.38}
                    y={433.67}
                    width={39.82}
                    height={40.46}
                    rx={3.34}
                    fill="#d0b6d1"
                  />
                  <path
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeMiterlimit={10}
                    strokeWidth={1.2}
                    opacity={0.81}
                    d="M147.03 467.66h23.59M147.03 463.31h27.78M147.03 458.97h23.59M147.03 454.16h12.22M147.03 450.37h17.88M147.03 446.39h23.59M147.03 442.04h27.78M147.03 437.7h23.59"
                  />
                </g>
              </g>
            </g>
          </g>
          <path fill="#ddd" d="M133.98 243.95h52.38v4.25h-52.38z" />
          <ellipse cx={136.91} cy={246.08} rx={0.93} ry={0.92} fill="#afafaf" />
          <ellipse cx={140.38} cy={246.08} rx={0.93} ry={0.92} fill="#eaeaea" />
          <ellipse cx={143.69} cy={246.08} rx={0.93} ry={0.92} fill="#afafaf" />
          <path fill="#eaeaea" d="M133.88 330.05h52.47v2.85h-52.47z" />
          <path fill="#fff" d="M182.52 248.2h3.84v81.84h-3.84z" />
          <rect
            x={183.24}
            y={249.77}
            width={2.4}
            height={22.21}
            rx={1.02}
            fill="#ddd"
            data-svg-origin="183.24000549316406 249.77000427246094"
            transform="translate(0 57.746)"
            style={{
              transformOrigin: '0 0',
            }}
          />
        </g>
      </g>
    </svg>
  );
}

export default MonitorSvg;
